/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "^gsap" }] */
import { each } from 'lodash';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// used by marine units for the About background row spanning, no parallax
const SpanningBackground = {
  spanningcount: 0,

  getClosestParent(item, classname) {
    let parent = document.body;
    for (let el = item; el && el !== document; el = el.parentNode) {
      if (el.classList.contains(classname)) {
        parent = el;
        break;
      }
    }
    return parent;
  },

  wrapInSpanningBackground(item) {
    const len = parseInt(item.getAttribute('data-spanning-span'), 10) || 0;

    const spanningimage = item.getAttribute('data-spanning-image-full');
    if (spanningimage) {
      const spanningbkgColor = item.getAttribute('data-spanning-background-color') || '#000';
      const spanningimagesmaller = (item.getAttribute('data-spanning-image-tablet') ? item.getAttribute('data-spanning-image-tablet') : spanningimage);
      const spanningcontainer = this.getClosestParent(item, 'row');
      const spanningstyle = '.spanning-background-image' + this.spanningcount + ' {background: ' + spanningbkgColor + ' url(' + spanningimage + ');background-position: top; background-size: 100% auto; background-repeat: no-repeat;} @media screen and (max-width: $media-breakpoint-md) {.spanning-background-image' + this.spanningcount + ' {background: ' + spanningbkgColor + ' url(' + spanningimagesmaller + '),background-position: top; background-size: 100% auto; background-repeat: no-repeat;}}';
      $('<style>').text(spanningstyle).appendTo(document.head);

      const spanningwrapper = document.createElement('div');
      spanningwrapper.className = 'spanning-background-image spanning-background-image' + this.spanningcount;
      spanningwrapper.id = `spanning-background-${++this.spanningcount}`;

      const spanningrowwrapper = document.createElement('div');
      spanningrowwrapper.className = 'container';
      spanningwrapper.appendChild(spanningrowwrapper);
      spanningcontainer.parentNode.insertBefore(spanningwrapper, spanningcontainer);

      if (len > 0) {
        for (let j = 0; j < len; j++) {
          const sibling = spanningwrapper.nextElementSibling;
          if (sibling) {
            spanningrowwrapper.appendChild(sibling);
          }
        }
      }
    }
  },

  init() {
    const spanBkgWrappercallers = document.querySelectorAll('[data-spanning-background]');
    each([...spanBkgWrappercallers], (item) => {
      this.wrapInSpanningBackground(item);
    });
  },
};

const SpanningParallax = {
  count: 0,

  getClosestParent(item, classname) {
    let parent = document.body;
    for (let el = item; el && el !== document; el = el.parentNode) {
      if (el.classList.contains(classname)) {
        parent = el;
        break;
      }
    }
    return parent;
  },

  // used by home page custom parallax backgroud that span modules
  // (under X (formerly Twitter), html, imagelinks modules)
  wrapInParallax(item) {
    const len = parseInt(item.getAttribute('data-parallax-span'), 10) || 1;
    if (len <= 1) return;

    const image = item.getAttribute('data-parallax-image');
    const overflow = item.getAttribute('data-parallax-overflow') || 'hidden';
    const container = this.getClosestParent(item, 'DnnModule');

    const wrapper = document.createElement('div');
    wrapper.innerHTML = `<div class="magic-bg" style="background-image: url(${image});"></div>`;
    wrapper.className = 'magic-parallax';
    wrapper.id = `magic-parallax-${++this.count}`;
    wrapper.style.overflow = `${overflow}`;
    container.parentNode.insertBefore(wrapper, container);

    gsap.to(`#${wrapper.id} > div.magic-bg`, {
      yPercent: 15,
      ease: 'none',
      scrollTrigger: {
        trigger: wrapper,
        scrub: true,
      },
    });

    for (let j = 0; j < len; j++) {
      const sibling = wrapper.nextSibling;
      if (sibling) {
        wrapper.appendChild(sibling);
      }
    }
  },

  init() {
    const callers = document.querySelectorAll('[data-parallax]');
    each([...callers], (item) => {
      this.wrapInParallax(item);
    });
  },
};

// used by articlecs content types for hero parallax
const ParallaxBanner = {
  create(item) {
    if (!item.getAttribute('id')) {
      item.setAttribute('id', `hero-parallax-${Date.now()}`);
    }

    if (item) {
      gsap.to(`#${item.id} > div.magic-bg`, {
        backgroundPosition: '50% 0%',
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });
    }
  },

  init() {
    const banners = document.querySelectorAll('.magic-parallax-banner');
    each([...banners], (item) => {
      this.create(item);
    });
  },
};

function Page() {
  SpanningBackground.init();
  SpanningParallax.init();
  ParallaxBanner.init();
}

export default Page;
